export class ListOfEmploymentRelation {
	id: number;
	name: string;
}
